import React from "react";
import { Link } from "react-router-dom";
import { FaEye, FaBullseye, FaCheckCircle, FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";

const About = () => {
  return (
    <div className="bg-white dark:bg-gray-950 min-h-screen w-full pt-0">

      {/* ── HERO — about1.jpg full-width bg ── */}
      <div
        className="relative w-full h-64 sm:h-80 md:h-96 flex flex-col items-center justify-center text-center"
        style={{
          backgroundImage: "url('/hero1.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative z-0 px-4">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white drop-shadow-2xl">
            About Us
          </h1>
          <p className="text-amber-600 dark:text-amber-400 font-semibold mt-4 italic">
              Real People. Real Service. Real Care.
            </p>
          {/* <p className="mt-3 text-base sm:text-lg text-gray-200 max-w-xl mx-auto">
            Learn about our history, vision, mission, and what makes us unique.
          </p> */}
        </div>
      </div>

    

      {/* ── ABOUT THE BRAND (image left, text right) ── */}
      <div className="bg-gray-50 dark:bg-gray-900 py-14">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row gap-10 items-center">
          <div className="w-full md:w-[45%] flex-shrink-0">
            <img
              src="/about1.jpg"
              alt="VETH INTERIORS team"
              className="w-full h-72 md:h-96 object-cover rounded-2xl shadow-lg"
            />
          </div>
          <div className="flex-1 text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-4">
              About VETH INTERIORS
            </h2>
          
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">
              For over <strong>15 years</strong>, we have remained committed to providing quality products, excellent customer service, and a shopping experience customers can truly rely on. What started as a passion for delivering tasteful and reliable products has grown into a business built on trust, consistency, and customer satisfaction.
            </p>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">
              Every order we receive is handled with care, attention, and professionalism — because we understand that every customer matters. We are not just another online store — we are a dedicated team that values honesty, quality service, and long-term customer relationships.
            </p>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
              From elegant wall art and decorative mirrors to luxurious throw covers, aromatic fragrances, and statement furniture — every product in our collection is carefully selected to help you create a home you are proud of.
            </p>
            <Link
              to="/shop"
              className="inline-block mt-6 px-8 py-3 bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold rounded-full hover:shadow-lg transition-all duration-300"
            >
              Explore Our Collection
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full mx-auto mt-0">
            <img
              src="/about2.png"
              alt="Our team at work"
              className="w-full h-full object-cover rounded-2xl shadow-lg"
            />
          </div>

      {/* ── VISION & MISSION ── */}
      <div className="max-w-6xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Vision */}
        <div className="flex gap-4 items-start p-6 bg-white dark:bg-gray-900 rounded-2xl shadow border border-gray-100 dark:border-gray-700">
          <span className="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-800 flex items-center justify-center">
            <FaEye className="text-amber-600 dark:text-amber-300 text-xl" />
          </span>
          <div>
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Our Vision</h2>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
              To be Nigeria's most trusted home and lifestyle brand — delivering elegance, comfort, and quality that transforms every living space into a sanctuary of luxury and self-expression.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="flex gap-4 items-start p-6 bg-white dark:bg-gray-900 rounded-2xl shadow border border-gray-100 dark:border-gray-700">
          <span className="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 dark:bg-amber-800 flex items-center justify-center">
            <FaBullseye className="text-amber-600 dark:text-amber-300 text-xl" />
          </span>
          <div>
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Our Mission</h2>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
              To ensure every customer receives quality products with proper attention, care, and satisfaction — from product selection to packaging and delivery — while maintaining standards that reflect over 15 years of experience.
            </p>
          </div>
        </div>
      </div>

      {/* ── OUR COMMITMENT ── */}
      <div className="max-w-6xl mx-auto px-4 py-14">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">Our Commitment</h2>
          <p className="text-gray-500 dark:text-gray-400 mt-2 max-w-2xl mx-auto text-sm">
            At the heart of our business is a simple goal: to ensure every customer receives quality products with proper attention, care, and satisfaction.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {[
            "Reliable service",
            "Honest communication",
            "Quality products",
            "Careful handling of orders",
            "Fast and responsive support",
            "A smooth shopping experience",
          ].map((item) => (
            <div
              key={item}
              className="flex items-center gap-3 p-4 bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-100 dark:border-gray-700"
            >
              <FaCheckCircle className="text-amber-500 text-lg flex-shrink-0" />
              <span className="text-gray-700 dark:text-gray-300 text-sm font-medium">{item}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── WHY CUSTOMERS TRUST US ── */}
      <div className="bg-gray-50 dark:bg-gray-900 py-14">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">Why Customers Trust Us</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { title: "15+ Years of Experience", desc: "We have spent years building trust through consistency, professionalism, and dependable service." },
              { title: "Customer Satisfaction First", desc: "We value every customer and work hard to ensure a positive shopping experience from start to finish." },
              { title: "Careful Packaging", desc: "Orders are handled with proper care and attention to maintain product quality during delivery." },
              { title: "Quality & Taste", desc: "We focus on offering products that reflect style, quality, and customer preference." },
              { title: "Responsive Support", desc: "We believe communication matters and remain available to assist customers when needed." },
              { title: "Nationwide Delivery", desc: "We deliver to all states across Nigeria. Distance is never a barrier to excellent service." },
            ].map(({ title, desc }) => (
              <div
                key={title}
                className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow border border-gray-100 dark:border-gray-700 hover:border-amber-400 dark:hover:border-amber-500 transition-all"
              >
                <h3 className="font-bold text-gray-900 dark:text-white mb-2 text-sm">{title}</h3>
                <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── MANAGEMENT / TEAM ── */}
      <div className="max-w-6xl mx-auto px-4 py-14">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white uppercase tracking-wide">
            Management
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-2 text-sm">
            Our team is committed to excellence and a seamless digital experience.
          </p>
        </div>
        <div className="flex justify-center">
          {/* Web Manager Card */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow border border-gray-100 dark:border-gray-700 p-6 text-center w-full max-w-sm hover:shadow-xl transition-all">
            <img
              src="/webmanager.jpg"
              alt="Mene Goi"
              className="w-36 h-36 rounded-full object-cover mx-auto border-4 border-amber-400 shadow-md mb-4"
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/150?text=MG";
              }}
            />
            <h3 className="font-bold text-gray-900 dark:text-white text-lg">Mene Goi</h3>
            <p className="text-amber-600 dark:text-amber-400 text-sm font-semibold mt-1">
              Website &amp; Digital Operations Manager
            </p>
            <p className="text-gray-500 dark:text-gray-400 text-xs mt-3 leading-relaxed">
              Responsible for managing website updates, ensuring smooth performance, and overseeing all digital activities to maintain a seamless user experience.
            </p>

            {/* Skill badges */}
            <div className="flex flex-wrap justify-center gap-2 mt-4">
              {["⚡ Site Speed", "🔒 Secure Checkout", "🛒 User Experience"].map((badge) => (
                <span
                  key={badge}
                  className="px-3 py-1 bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 text-xs font-semibold rounded-full border border-amber-200 dark:border-amber-700"
                >
                  {badge}
                </span>
              ))}
            </div>

            {/* Live status badge */}
            <div className="flex items-center justify-center gap-1.5 mt-4">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500"></span>
              </span>
              <span className="text-xs text-green-600 dark:text-green-400 font-semibold">
                System Status: Fully Operational
              </span>
            </div>

            {/* Contact links */}
            <div className="mt-4 space-y-1 text-xs text-gray-500 dark:text-gray-400">
              <p>
                🌐{" "}
                <a
                  href="mailto:Web-ops@Vethinteriors.com"
                  className="text-amber-600 dark:text-amber-400 hover:underline"
                >
                  Web-ops@Vethinteriors.com
                </a>
              </p>
              <p>
                📥{" "}
                <a
                  href="mailto:support@vethinteriors.com"
                  className="text-amber-600 dark:text-amber-400 hover:underline"
                >
                  support@vethinteriors.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ── CONTACT / CTA ── */}
      <div className="bg-gradient-to-r from-amber-600 to-yellow-600 py-14">
        <div className="max-w-4xl mx-auto px-4 text-center text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-3">Get In Touch</h2>
          <p className="text-amber-100 mb-8 text-sm">
            We are ready to serve you. Reach out via any of the channels below.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap">
            <a
              href="tel:+2348106079897"
              className="flex items-center gap-2 justify-center bg-white text-amber-700 font-bold px-6 py-3 rounded-full hover:shadow-lg transition-all"
            >
              <FaPhone /> 08106079897
            </a>
            <a
              href="https://wa.me/2348106079897"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 justify-center bg-green-600 text-white font-bold px-6 py-3 rounded-full hover:bg-green-700 transition-all"
            >
              <FaWhatsapp /> WhatsApp Us
            </a>
            <a
              href="mailto:support@vethinteriors.com"
              className="flex items-center gap-2 justify-center bg-white/20 border-2 border-white text-white font-bold px-6 py-3 rounded-full hover:bg-white/30 transition-all"
            >
              <FaEnvelope /> support@vethinteriors.com
            </a>
          </div>
          <div className="mt-8">
            <Link
              to="/shop"
              className="inline-block bg-white text-amber-700 font-bold px-10 py-3 rounded-full hover:shadow-xl transition-all"
            >
              Shop Now
            </Link>
          </div>
        </div>
      </div>
     
    </div>
  );
};

export default About;
